import {createSelector} from 'reselect';
import getMetadata from './getMetadata';

export default createSelector(
  [getMetadata],
  metadata => metadata?.PRIVACY_CONSENT_GROUPS,
);
